import React, { useEffect, useRef, useState } from 'react';
import { fetchRegionais } from '../../../../api/contac/contacRegionaisApi';
import { notify } from '../../../../shared/feedback/notify';
import './ModalSelecionarRegionalUnico.css';

interface Regional {
  value: number;
  label: string;
}

interface ModalSelecionarRegionalUnicoProps {
  selected?: string;
  onClose: () => void;
  onSelect: (codigo: number, nome: string) => void;
}

const ModalSelecionarRegionalUnico: React.FC<ModalSelecionarRegionalUnicoProps> = ({
  selected,
  onClose,
  onSelect,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [regionais, setRegionais] = useState<Regional[]>([]);
  const [selecionada, setSelecionada] = useState<string | undefined>(selected);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const loadRegionais = async (p: number) => {
    try {
      const data = await fetchRegionais(p, limit);
      setRegionais(data.data.map((r: any) => ({
        value: Number(r.codigoRegional),
        label: r.nomeFantasia || r.nome
      })));
      setTotalPages(data.totalPages);
    } catch (error) {
      // Sem sinal, a lista vazia parece "nenhuma regional cadastrada" em vez de falha de carga.
      console.error('Erro ao carregar regionais:', error);
      setRegionais([]);
      notify.errorFrom(error, 'Não foi possível carregar a lista de regionais. Recarregue a página; se persistir, acione a TI.');
    }
  };

  useEffect(() => {
    loadRegionais(page);
  }, [page]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const handleConfirm = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selecionada) {
      onSelect(0, '');
      return;
    }

    const regionalSelecionada = regionais.find(r => r.value === Number(selecionada));
    if (regionalSelecionada) {
      onSelect(regionalSelecionada.value, regionalSelecionada.label);
    }
  };

  return (
    <div className="add-car-modal-overlay">
      <div className="contac-modal-content" ref={modalRef}>
        <div className="LightboxContac">
          <form className="LightboxLogin" onSubmit={handleConfirm}>
            <div className="EditarCarro">Selecionar Regional</div>

            <div className="Frame1000004010" style={{ gap: '1rem', maxHeight: '300px', overflowY: 'auto' }}>
              {regionais.map(({ value, label }) => (
                <label key={value} className="Cam label-radio AmpleSoft-Regular" style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="radio"
                    name="regional"
                    value={value}
                    checked={selecionada === value.toString()}
                    onChange={() => setSelecionada(value.toString())}
                    style={{ marginRight: 8 }}
                  />
                  {label}
                </label>
              ))}
            </div>

            <div className="PaginacaoContac">
              <button className="CtaBigContac save" type="button" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>Anterior</button>
              <span className="AmpleSoft-Regular">Página {page} de {totalPages}</span>
              <button className="CtaBigContac save" type="button" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}>Próxima</button>
            </div>

            <div className="Frame1000003998" style={{ marginTop: '2rem' }}>
              <div className="CtaBigEditar cancel" onClick={onClose}>
                <button className="CustomFileCancel" type="button">Cancelar</button>
              </div>
              <button
                className="CtaBigEditar save"
                type="button"
                onClick={() => {
                  setSelecionada(undefined);
                  onSelect(undefined as any, 'Selecionar regional');
                  onClose();
                }}
              >
                Limpar
              </button>
              <button className="CtaBigEditar save" type="submit">
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalSelecionarRegionalUnico;
